<script lang="ts">
    import {getLocalization} from 'src/core';
    import type {Datatype} from 'src/typings';
    import {pipe} from 'core/utils';
    import locFilter from '../../filters/loc';
    import {exists, isNull} from '../../utils/custom-utils';

    export let datatype: Datatype;
    export let value;
    export let fallback = '';

    const DATATYPE_BOOLEAN = 'BOOLEAN';
    const localize = getLocalization();

    $: title = value?.id;
    $: cssClasses = value && value.id ? 'label label-default' : null;
    $: ariaLabel = exists(value) && isBoolean(datatype) ? booleanLabel() : null;
    $: text = localizedText(value, datatype);

    function localizedText(scalarValue, scalarDatatype) {
        if (isNull(scalarValue)) {
            return fallback;
        }
        if (isBoolean(scalarDatatype)) {
            return scalarValue ? '\u2714' : '\u2718'; // check or cross symbols
        }
        return pipe(scalarValue, locFilter());
    }

    function isBoolean(type) {
        return type?.name === DATATYPE_BOOLEAN;
    }

    function booleanLabel() {
        return value ? localize(/* @kp-localization commons.ANO */ 'commons.ANO') : localize(/* @kp-localization commons.NE */ 'commons.NE');
    }

</script>

<span class={cssClasses} {title}>
    {text}
    {#if ariaLabel}
        <span class="sr-only">{ariaLabel}</span>
    {/if}
</span>